import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderPdfModule } from 'src/features/service-order/order-pdf/order-pdf.module';
import { ServiceOrderActionsModule } from 'src/features/service-order/services-os-actions/services-os-actions.module';
import { DialogEditTicketAmountComponent } from 'src/features/ticketeria/edit-ticket-amount/ui/dialog-edit-ticket-amount/dialog-edit-ticket-amount.component';
import { EditarNumberTicketsComponent } from './editar-number-tickets/editar-number-tickets.component';
import { TableExpandComponent } from './table-expand.component';
import { VerPdfComponent } from './ver-pdf/ver-pdf.component';

/**
 * Expand de tickets (Ticketería / detalle file / OS masivas).
 * Exporta `app-table-expand` para reutilizar la misma tabla hija.
 */
@NgModule({
  declarations: [
    TableExpandComponent,
    DialogEditTicketAmountComponent,
    EditarNumberTicketsComponent,
    VerPdfComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule,
    MatDialogModule,
    MatSortModule,
    MatTooltipModule,
    TablerIconsModule,
    OrderPdfModule,
    ServiceOrderActionsModule
  ],
  exports: [TableExpandComponent]
})
export class TicketsTableExpandModule {}
